import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
const objections = [{
  question: '¿Es para mí si recién empiezo a jugar?',
  answer: 'Sí, el sistema está diseñado para jugadores de todos los niveles. Los módulos tienen progresiones claras desde lo básico hasta lo avanzado, así que podés arrancar desde donde estés y avanzar a tu ritmo.'
}, {
  question: '¿Necesito cancha o gimnasio para seguir el plan?',
  answer: 'No es obligatorio. Muchos ejercicios se pueden hacer en casa o en espacios reducidos. El sistema está pensado para jugadores que no tienen acceso constante a instalaciones profesionales.'
}, {
  question: '¿Cuánto tiempo necesito entrenar por semana?',
  answer: 'El plan se adapta a tu disponibilidad. Hay opciones para 2, 3 o 4 días por semana. Lo importante es la consistencia, no la cantidad de horas.'
}, {
  question: '¿Qué pasa si no veo resultados?',
  answer: 'El sistema está probado con cientos de jugadores. Si seguís el plan con constancia durante las 8 semanas, vas a ver mejoras reales. Los testimonios de otros jugadores lo confirman.'
}, {
  question: '¿Los bonos son realmente gratis?',
  answer: 'Sí, los 4 bonos están incluidos sin costo adicional con tu compra de hoy. Son herramientas que complementan el sistema principal y te ayudan a seguir tu progreso.'
}, {
  question: '¿Cómo accedo al contenido después de comprar?',
  answer: 'Inmediatamente después del pago recibís un email con todos los links de descarga. Podés acceder desde cualquier dispositivo y el contenido es tuyo para siempre.'
}];
export function Objections() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-gray-50 py-12 md:py-16 px-4" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-70">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-71">
          {objections.map((objection, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200" data-id="element-72">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-5 text-left hover:bg-blue-50 transition-colors" data-id="element-73">
                  <div className="flex items-center gap-3" data-id="element-74">
                    <HelpCircleIcon className="w-6 h-6 text-blue-600 flex-shrink-0" data-id="element-75" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-76">
                      {objection.question}
                    </h3>
                  </div>
                  <ChevronDownIcon className={`w-6 h-6 text-blue-600 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-77" />
                </button>

                <AnimatePresence data-id="element-78">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-79">
                      <div className="p-5 pt-0 border-t border-gray-100" data-id="element-80">
                        <p className="text-gray-700" data-id="element-81">{objection.answer}</p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}